import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  OnChanges,
  SimpleChange
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable } from "rxjs";

import { Questionario } from "../models/questionario";
import { CategoriaPergunta } from "../models/categoria-pergunta";
import { Resposta } from "../models/resposta";
import { RespostaItem } from "../models/resposta-item";
import { Question } from "../models/question";
import { QuestionModel } from "../models/question-model";
import { TipoRespostaEnum } from "../util/tipo-resposta.enum";

import { QuestionarioDinamicoService } from "../services/questionario-dinamico.service";

@Component({
  selector: "filtro-dinamico",
  template: `
    <div *ngIf="isLoading" [ngClass]="{'block-content':isLoading}">
      <mat-progress-spinner mode="indeterminate" ></mat-progress-spinner>
    </div>

    <!-- Formulario Filtro Dinamico -->
    <div class="alert {{mensagem[1]}}" *ngIf="mensagem">
      <strong> {{mensagem[0]}} </strong>
    </div>
    <div class="card" *ngIf="!isLoading">
      <div class="header">
        <h2>Filtro</h2>
      </div>
      <div class="body">
      <form [formGroup]="form" *ngIf="questionModel && questionModel.questions.length > 0" style="margin-top: 20px;" >
        <div *ngFor="let question of questionModel.questions">
          <div *ngIf="question.perguntaVinculada == null || (question.perguntaVinculada !=null &&  form.controls[question.perguntaVinculada.opcao.pergunta] != null && form.controls[question.perguntaVinculada.opcao.pergunta].value == question.perguntaVinculada.idOpcao)" >
            <div class="form-group form-float">

              <div class="form-line" [ngSwitch]="question.controlType">
                <div *ngSwitchCase="'textbox'">
                  <mat-form-field class="full-width">
                     <input matInput placeholder="{{question.text}}"  id="{{question.key}}" [formControlName]="question.key" >
                   </mat-form-field>
                </div>
                <div *ngSwitchCase="'inteiro'" >
                  <mat-form-field class="full-width">
                     <input matInput placeholder="{{question.text}}"  id="{{question.key}}" [formControlName]="question.key" type="number" min="0" step="1" >
                   </mat-form-field>
                </div>
                <div *ngSwitchCase="'decimal'" >
                  <mat-form-field class="full-width">
                     <input matInput placeholder="{{question.text}}"  id="{{question.key}}" [formControlName]="question.key" type="number" >
                   </mat-form-field>
                </div>
                <div *ngSwitchCase="'data'">
                  <label>{{question.text}}</label>
                  <input matInput placeholder="{{question.text}}" type="date" id="{{question.key}}" [formControlName]="question.key" >
                </div>
                <div *ngSwitchCase="'textarea'">
                  <mat-form-field>
                    <textarea matInput  placeholder="{{question.text}}" id="{{question.key}}" [formControlName]="question.key"></textarea>
                  </mat-form-field>
                </div>
                <div *ngSwitchCase="'dropdown'" >
                  <mat-select placeholder="{{question.text}}" [formControlName]="question.key">
                    <mat-option *ngFor="let o of question.options" [value]="o.id">
                      {{o.descricao}}
                    </mat-option>
                  </mat-select>
                </div>
                <div *ngSwitchCase="'radio'">
                  <div>
                    <label>{{question.text}}</label>
                  </div>
                  <mat-radio-group class="radio-vertical" [formControlName]="question.key">
                    <mat-radio-button *ngFor="let o of question.options"  [value]="o.id">
                      {{o.descricao}}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div *ngSwitchCase="'select-multiple'" >
                <label>{{question.text}}</label>
                  <div *ngFor="let o of question.options" class="checkbox">
                    <label>
                      <input type="checkbox" [formControlName]="question.key" [value]="o.id" (change)= "updateMultipleComponent(o.id, $event.target.checked, null, question.key)"> {{o.descricao}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <button  mat-raised-button color="primary" type="submit" *ngIf="botaoPesquisar" (click)="filtrar(form.value, form.valid)">
        <mat-icon >search </mat-icon>
            Buscar
      </button>
      <button  mat-raised-button color="primary" *ngIf="botaoResetar" (click)="resetar()">
        <mat-icon >clear </mat-icon>Limpar
      </button>
    </form>
    </div>
    </div>
    <!-- #END# Formulario Filtro Dinamico -->

    <div class="body">
      <resposta-list-dinamico  *ngIf="idQuestionario != null && idQuestionario != 0" [idQuestionario]="idQuestionario" [filtro]="filtro" [botaoSelecionar]="botaoSelecionar" (respostaEmitida)="reemitirResposta($event)"> </resposta-list-dinamico>
    </div>

    `
})
export class FiltroDinamicoComponent implements OnChanges {
  // idQuestionario vem da pagina que usara o componente
  @Input() idQuestionario: number;
  // nomeUnico vem da pagina que usara o componente
  @Input() nomeQuestionario: string;
  // respostas do questionario que pode vim de outra pagina
  @Input() resposta: Resposta;
  // botao para resetar formulario
  @Input() botaoResetar: boolean;
  // botao para salvar formulario
  @Input() botaoPesquisar: boolean;
  // determina se aparece um botao de selecionar, que emite o valor selecionado pra manipulacao
  @Input() botaoSelecionar: boolean = false;
  // emite a resposa selecionada
  @Output() respostaEmitida: EventEmitter<number> = new EventEmitter<number>();

  public filtro: Resposta = new Resposta();

  public mensagem: [string, string];

  public questionario: Questionario;

  public questionarioCompleto: Questionario;
  public categorias: CategoriaPergunta[];

  public form: FormGroup;
  public questionModel = new QuestionModel();
  // Controla o loading da página
  public isLoading: boolean;
  public filtroUsuario: string;
  public filtroDataCriacao: Date;

  public multipleComponentChecked: Array<{
    idOpcao: number;
    value: boolean;
    idItem: number;
    idPergunta: number;
  }> = new Array<{
    idOpcao: number;
    value: boolean;
    idItem: number;
    idPergunta: number;
  }>();

  constructor(
    public questionarioDinamicoService: QuestionarioDinamicoService
  ) {}

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.questionario = new Questionario();
    if (this.idQuestionario || this.nomeQuestionario) {
      this.carregaQuestionario();
    } else {
      this.mensagem = [
        "Erro: " + "Entre com um valor para o idQuestionario",
        "alert-danger"
      ];
    }
  }

  // Aki eu recebo o valor emitido lah do meu respostaLista e reemito ele
  reemitirResposta(event: number) {
    this.respostaEmitida.emit(event);
  }

  public carregaQuestionario() {
    this.isLoading = true;
    this.questionModel = new QuestionModel();
    let questionarioRecuperado: Observable<Questionario> = new Observable<
      Questionario
    >();
    if (this.idQuestionario) {
      questionarioRecuperado = this.questionarioDinamicoService.recuperaFiltroQuestionarioCompleto(
        this.idQuestionario
      );
    } else if (this.nomeQuestionario) {
      questionarioRecuperado = this.questionarioDinamicoService.recuperaFiltroQuestionarioCompletoPorNomeUnico(
        this.nomeQuestionario
      );
    }

    questionarioRecuperado.subscribe(
      resultQuestionario => {
        this.questionario = resultQuestionario;
        this.idQuestionario = this.questionario.id;
        if (resultQuestionario && resultQuestionario.categorias) {
          this.form = this.questionModel.carregaForm(
            resultQuestionario.categorias,
            true
          );
        }
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  /*
  * Metodo que controla as opcoes do checkbox.
  * Primeiro ele filtra na lista de checkbox pra ver se o checkbox existe na lista
  * Depois ele inclui ou altera o valor do checkbox.
  */
  updateMultipleComponent(
    option: any,
    valorOpcao: any,
    item: number,
    pergunta: number
  ) {
    // busco pra ver se a opcao jah existe no meu array
    let existe = this.multipleComponentChecked
      .filter(valor => valor.idOpcao == option)
      .filter(valor => valor.idPergunta == pergunta);
    if (!existe || (existe && existe.length == 0)) {
      this.multipleComponentChecked.push({
        idOpcao: option,
        value: valorOpcao,
        idItem: item,
        idPergunta: pergunta
      });
    } else {
      // agora filtro o meu resultado novamente e faco o map mudado o valor pro valor atual
      this.multipleComponentChecked
        .filter(valor => valor.idOpcao == option)
        .filter(valor => valor.idPergunta == pergunta)
        .map(valor => {
          valor.value = valorOpcao;
          if (item) {
            valor.idItem = item;
          }
        });
    }
  }

  filtrar(formulario: any, isValid: boolean) {
    this.filtro = this.preencheFiltro();
  }

  preencheFiltro() {
    let resposta: Resposta = new Resposta();
    resposta.listaRespostaItem = new Array();
    this.questionario.categorias.forEach(cat => {
      cat.perguntas.forEach(per => {
        let itemResposta: RespostaItem = new RespostaItem();
        resposta.questionario = this.questionario.id;
        itemResposta.pergunta = per.id;
        // 0 escolha uma, 1 multipla escolha, 4 combo
        if (
          per.tipoResposta == TipoRespostaEnum.EscolhaUma ||
          per.tipoResposta == TipoRespostaEnum.Combo
        ) {
          if (this.form.controls[per.id].value != "") {
            // tenho que recuperar a opcao com base na pergunta preenchida
            let itemRespostaOpcaoPreenchida = this.questionarioDinamicoService.preencherOpcao(
              per,
              this.form.controls[per.id].value
            );
            itemResposta.opcao = itemRespostaOpcaoPreenchida.opcao;
            itemResposta.opcaoValor = itemRespostaOpcaoPreenchida.opcaoValor;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (
          per.tipoResposta == TipoRespostaEnum.TextoSimples ||
          per.tipoResposta == TipoRespostaEnum.TextoGrande
        ) {
          if (this.form.controls[per.id].value != "") {
            itemResposta.descricao = this.form.controls[per.id].value;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (
          per.tipoResposta == TipoRespostaEnum.Inteiro ||
          per.tipoResposta == TipoRespostaEnum.Decimal
        ) {
          if (this.form.controls[per.id].value != "") {
            itemResposta.numero = this.form.controls[per.id].value;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (per.tipoResposta == TipoRespostaEnum.Data) {
          if (this.form.controls[per.id].value != "") {
            itemResposta.data = this.form.controls[per.id].value;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (per.tipoResposta == TipoRespostaEnum.MultiplaEscolha) {
          this.multipleComponentChecked.forEach(x => {
            // tenho que verificar se a pergunta q estou inserindo tem o mesmo id da pergunta no multipleComponentChecked
            // se nao tiver isso ele inclui mais de uma vez se tiver dois componentes de checkbox
            if (per.id == x.idPergunta) {
              let item: RespostaItem = new RespostaItem();
              item.id = x.idItem;
              item.pergunta = x.idPergunta;
              item.opcao = x.idOpcao;
              if (x.value == true) {
                item.opcaoValor = x.idOpcao;
              } else {
                // essa eh uma forma de falar que o item foi excluido
                item.opcaoValor = 0;
              }
              resposta.listaRespostaItem.push(item);
            }
          });
        }
      });
    });

    return resposta;
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem = ["Erro: " + erro, "alert-danger"];
    this.isLoading = false;
  }

  resetar(){
    //TODO: método vazio
  }

  // finaliza o subscribe
  finaliza() {
    this.isLoading = false;
  }
}
